import Modal from './Modal';
import ModalBody from './ModalBody';
import ModalDialog from './ModalDialog';
import ModalFooter from './ModalFooter';
import ModalHeader from './ModalHeader';
import ModalTitle from './ModalTitle';

// export types
export type { ModalProps } from './Modal';
export type { ModalBodyProps } from './ModalBody';
export type { ModalDialogProps } from './ModalDialog';
export type { ModalFooterProps } from './ModalFooter';
export type { ModalHeaderProps } from './ModalHeader';
export type { ModalTitleProps } from './ModalTitle';
export type { ModalSize } from './utils';

// export components
export { Modal, ModalBody, ModalDialog, ModalFooter, ModalHeader, ModalTitle };
export default Modal;
